const INITIAL_STATE = {
  pontoEmbarqueList: {
    data: []
  },
  pontoEmbarqueDado: null,
  pontoEmbarque: null,
  produtoHorario: [],
  tourHorario: [],
  tourProduto: [],
  pontoEmbarquePagination: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'EMBARQUE_FETCH':
      return { ...state, pontoEmbarqueList: action.payload }
    case 'PONTO_EMBARQUE_FETCH':
      if (action.payload) {
        const produtos = action.payload.tourProduto.produtos.map(p => {
          return { horario: p.hor_horario, pro_id: p.pro_id, nome: p.pro_nome, hor_id: p.hor_id, tour: p.tou_nome}
        })

        const tours = action.payload.tourProduto.tours.map(t => {
          return { horario: t.hor_horario, tou_id: t.tou_id, nome: t.tou_nome, hor_id: t.hor_id }
        })

        return {
          ...state,
          pontoEmbarqueDado: action.payload,
          produtoHorario: produtos,
          tourHorario: tours
        }
      } else {
        return { ...state, pontoEmbarqueDado: action.payload }
      }
    case 'EMBARQUE_SET':
      return { ...state, pontoEmbarque: action.payload }

    case 'PONTO_TOUR_PRODUTO_FETCH':
      const produtoHorarioCopy = [...state.produtoHorario]
      const tourHorarioCopy = [...state.tourHorario]
      const produtoDado = [...state.produtoHorario]
      const tourDado = [...state.tourHorario]

      action.payload.tourProduto.produtos.map((produto, i) => {
        produtoHorarioCopy[i] = { horario: produto.hor_horario, pro_id: produto.pro_id, nome: produto.pro_nome, hor_id: produto?.hor_id, tour: produto.passeio.tour.tou_nome }
      })
      
      produtoHorarioCopy.forEach((prod, i) => {
        for (const value of produtoDado) {
          
          if (prod.pro_id == value.hor_idproduto) {
            // console.log(produtoHorarioCopy , 'produtoHorarioCopy')
            produtoHorarioCopy[i] = { horario: value.hor_horario, pro_id: prod.pro_id, nome: prod.nome, hor_id: value?.hor_id }
          }
        }
      })

      action.payload.tourProduto.tours.map((tou, i) => {
        tourHorarioCopy[i] = { horario: tou.hor_horario, tou_id: tou.tou_id, nome: tou.tou_nome, hor_id: tou?.hor_id }
      })

      tourHorarioCopy.forEach((tour, i) => {
        for (const value of tourDado) {
          if (tour.tou_id == value.hor_idtour) {
            tourHorarioCopy[i] = { horario: value.hor_horario, tou_id: tour.tou_id, nome: tour.nome, hor_id: value?.hor_id }
          }
        }
      })

      if (action.editar) {
        return { ...state, tourProduto: action.payload }
      } else {
        return { ...state, tourProduto: action.payload, produtoHorario: produtoHorarioCopy, tourHorario: tourHorarioCopy }
      }
    case 'PONTO_PRODUTO_HORARIO_CHANGE': {
      const produtoHorarioCopy = [...state.produtoHorario]

      produtoHorarioCopy[action.index] = { horario: action.horario, pro_id: action.pro_id, nome: action.nome, hor_id: action?.hor_id }

      return { ...state, produtoHorario: produtoHorarioCopy }
    }
    case 'PONTO_TOUR_HORARIO_CHANGE': {
      const tourHorarioCopy = [...state.tourHorario]

      tourHorarioCopy[action.index] = { horario: action.horario, tou_id: action.tou_id, nome: action.nome, hor_id: action?.hor_id }

      return { ...state, tourHorario: tourHorarioCopy }
    }
    default:
      return state
  }
}